import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import clsx from "clsx";
import { animated, useSpring, config } from "react-spring";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
		imgContainer: { width: 100, height: "auto", margin: "auto" },
		img: { width: "100%" },
	});

export interface ErrorDisplayProps
	extends React.HTMLAttributes<HTMLDivElement> {
	message: React.ReactNode;
	src?: string;
}

const AnimatedTypography = animated(Typography);

const ErrorDisplay = React.forwardRef<
	HTMLDivElement,
	ErrorDisplayProps & WithStyles<typeof styles>
>(({ message, className, classes, src, ...divProps }, ref) => {
	const { scale, opacity, y } = useSpring({
		config: config.wobbly,
		scale: 1,
		opacity: 1,
		y: 0,
		from: { scale: 0.8, opacity: 0, y: 50 },
	});

	return (
		<div className={clsx(classes.root, className)} ref={ref} {...divProps}>
			<animated.div
				className={classes.imgContainer}
				style={{
					opacity,
					transform: scale.interpolate((s) => `scale(${s})`),
				}}
			>
				<img
					src={src}
					alt="Warning icon to show that an error has occured."
					className={classes.img}
				/>
			</animated.div>
			<AnimatedTypography
				variant="h6"
				align="center"
				style={{
					opacity,
					transform: y.interpolate((y) => `translateY(${y}px)`),
				}}
			>
				{message}
			</AnimatedTypography>
		</div>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("ErrorDisplay"),
})(ErrorDisplay);
